<template>
    <div class="video-call">
      <div class="video-container">
        <video ref="myVideo" autoplay playsinline></video>
        <video ref="peerVideo" autoplay playsinline></video>
      </div>
  
      <div class="actions">
        <button @click="startCall" :disabled="isCalling">Start Call</button>
        <button @click="endCall" :disabled="!isCalling">End Call</button>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref } from "vue";
  import Peer from "simple-peer"; // Biblioteca para WebRTC
  
  // Referências para os vídeos
  const myVideo = ref(null);
  const peerVideo = ref(null);
  
  // Estado da chamada
  const isCalling = ref(false);
  
  // Iniciar a chamada
  const startCall = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({
      video: true,
      audio: true
    });
  
    // Exibir o vídeo do próprio usuário
    myVideo.value.srcObject = stream;
  
    // Criar uma conexão peer
    const peer = new Peer({
      initiator: true,
      trickle: false,
      stream: stream
    });
  
    // Conectar com o outro peer quando o sinal for recebido
    peer.on("signal", signal => {
      // Enviar o sinal (via API ou WebSocket)
      // Enviar o signal para o outro usuário
      console.log("Sending signal to the other user:", signal);
      // Exemplo: use o WebSocket ou outra tecnologia para enviar
    });
  
    // Receber o vídeo do outro peer
    peer.on("stream", remoteStream => {
      peerVideo.value.srcObject = remoteStream;
    });
  
    // Salvar a instância do peer
    window.peer = peer;
  
    isCalling.value = true;
  };
  
  // Finalizar a chamada
  const endCall = () => {
    if (window.peer) {
      window.peer.destroy(); // Finaliza a chamada
    }
  
    isCalling.value = false;
    myVideo.value.srcObject.getTracks().forEach(track => track.stop()); // Parar a transmissão de vídeo
  };
  </script>
  
  <style scoped>
  .video-call {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
  }
  
  .video-container {
    display: flex;
    justify-content: space-between;
    width: 80%;
    margin-bottom: 20px;
  }
  
  video {
    width: 45%;
    border: 1px solid #ccc;
    border-radius: 8px;
  }
  
  .actions button {
    padding: 10px 20px;
    margin: 5px;
    font-size: 16px;
    cursor: pointer;
  }
  
  button:disabled {
    background-color: #ddd;
    cursor: not-allowed;
  }
  </style>
  